module.exports = __webpack_public_path__ + "static/bg-page-7-a53ade469da799f2337aad080228f756.jpg";